// extracted by mini-css-extract-plugin
export var active = "w_bd";
export var column = "w_bX";
export var columns = "w_bW";
export var container = "w_b";
export var link = "w_bs";
export var title = "w_h";